var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card_vars.length)?_c('div',{staticClass:"vars-list"},_vm._l((_vm.card_vars),function(val){return _c('div',{key:val.formulaCode,staticClass:"pa-0 text-start h7-text"},[_vm._v(" "+_vm._s(val.formulaCode)+" - \""+_vm._s(val.title)+"\" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }